// because the sliders have a weird UI, the focus sometimes jumps on the wrong slider.
import { Box } from "@mui/material"
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import _ from "lodash"
import React, { memo, RefObject } from "react"
import { NavigateFunction } from "react-router"

import { Slider, Sliders, TTeaser } from "../../../components/Sliders/Slider"
import { useTransitions } from "../../../hooks/use-transitions"
import { instantScroll } from "../../../utilities/common"
import { s } from "../../../utilities/common"
import { dimensions } from "../../../utilities/constants"

interface SliderProps {
  sliders?: Sliders
  addFocus: () => void
  navigate: NavigateFunction
  scrollRef?: RefObject<HTMLElement | null>
  marginTop: string | number
}
export const FocusedSliders = memo(
  ({ sliders, addFocus, navigate, scrollRef, marginTop }: SliderProps) => {
    const transition = useTransitions()
    const { ref, focusKey } = useFocusable()
    if (sliders?.length === 0) return null
    return (
      <FocusContext.Provider value={focusKey}>
        <Box
          ref={ref}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "min-content",
            pb: s("2px"),
            pt: s("2px"),
            mt: marginTop,
          }}
        >
          {sliders &&
            sliders.map((slider, sliderIndex) => (
              <Slider
                key={slider.title + slider.id}
                onPressTitle={(d?: TTeaser, teaserIndex?: number) => {
                  if (!d || teaserIndex === undefined) return
                  addFocus()
                  scrollRef?.current?.classList.add("loading_out")
                  navigate(
                    `../detail/${d.type}/${d.id}/${sliderIndex + 1}/${
                      teaserIndex + 1
                    }/${slider.id}`,
                  )
                }}
                onPressBrowse={() => {
                  addFocus()
                  scrollRef?.current?.classList.add("loading_out")
                  navigate(`../browse/0/${slider.id}/1/0`)
                }}
                onFocus={({ top: y, height }, _, query) => {
                  if (!(query && query.noScroll) && !!scrollRef?.current) {
                    instantScroll(scrollRef, query, transition)
                    scrollRef.current.style.transform =
                      "translate3d(0, " +
                      Math.min(0, -y + (dimensions.height - height) / 2) +
                      "px, 0)"
                  }
                }}
                title={slider.title}
                data={slider}
                dimensions={slider.style}
                margin={true}
              />
            ))}
        </Box>
      </FocusContext.Provider>
    )
  },
  (prevProps, nextProps) => {
    return (
      prevProps.scrollRef === nextProps.scrollRef &&
      _.isEqual(prevProps.sliders, nextProps.sliders)
    )
  },
)
